import { useQuery } from '@tanstack/react-query'
import { CertificateProgramsService } from '@mc/api'
import { CERTIFICATE_PROGRAM_TILES } from './constants'

export const useGetCertificateProgramTiles = () =>
  useQuery({
    queryKey: [CERTIFICATE_PROGRAM_TILES],
    queryFn: () => CertificateProgramsService.getCertificateProgramCatalog(),
    retry: 2,
  })
